// extracted by mini-css-extract-plugin
export var back = "SectionBreedDogs-module--back--ff649";
export var bordersection = "SectionBreedDogs-module--bordersection--7b7d6";
export var bordertop = "SectionBreedDogs-module--bordertop--e9b81";
export var buttonwrapper = "SectionBreedDogs-module--buttonwrapper--2b002";
export var curvedborder = "SectionBreedDogs-module--curvedborder--0bfc8";
export var introtext = "SectionBreedDogs-module--introtext--6a65c";
export var navbuttons = "SectionBreedDogs-module--navbuttons--495ac";
export var next = "SectionBreedDogs-module--next--bcee3";
export var spotlightdogsinner = "SectionBreedDogs-module--spotlightdogsinner--11261";
export var spotlightdogsouter = "SectionBreedDogs-module--spotlightdogsouter--3beeb";
export var swiper = "SectionBreedDogs-module--swiper--8734d";
export var swiperwrapper = "SectionBreedDogs-module--swiperwrapper--38d9f";
export var title = "SectionBreedDogs-module--title--a91b3 headings-module--sectionHeading--a8f67";
export var titlewrapper = "SectionBreedDogs-module--titlewrapper--ab5fb";